import { type IMenuList } from './type'
import { menuList } from './menuLIst.config'
import { type RouteObject } from 'react-router-dom'

const recursivePathSearch = (menulist: IMenuList[]) => {
  const _ = (id: string, curPath = '') => {
    let path = ''
    const currentMenu = menulist.find((l) => l.id === id)
    if (currentMenu == null) return path
    if (currentMenu?.parentId != null) {
      path = _(currentMenu.parentId, `/${currentMenu.path}${curPath}`)
    } else {
      path = `/${currentMenu.path}${curPath}`
    }
    return path
  }
  return _
}

export const searchPath = recursivePathSearch(menuList)

export const genRoutes = (menus: IMenuList[]) => {
  const result: RouteObject[] = []
  const parentMenuIds: string[] = []

  menus.forEach((r) => r.parentId != null && parentMenuIds.push(r.parentId))

  menus.forEach((r) => {
    if (parentMenuIds.includes(r.id)) return
    const path = searchPath(r.id)
    const routeItem: RouteObject = {
      id: r.id,
      path: path.startsWith('/') ? path.slice(1) : path,
      element: r.element
    }
    result.push(routeItem)
  })

  return result
}
